import { Component } from "react";
import { connect } from "react-redux";
import SearchInput from "../../shared-components/SearchInput";
import UsersTable from "./usersTable";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import NewUserModal from "./newUserModal";
import {
  showNewUserModal,
  setUsers,
  setInitialUsersData,
  setUsersDataIsLoading,
} from "../../redux-state/features/users";
import axios from "axios";
import urls from "../../urls";
import SearchUsers from "./searchUsers";
class UsersAccountManagement extends Component {
  componentDidMount() {
    const { faculty_id } = JSON.parse(localStorage.getItem("user"));

    this.props.setUsersDataIsLoading(true);
    axios
      .get(urls.getUsers(faculty_id), {})
      .then((res) => {
        const { results } = res.data;
        this.props.setUsers(results);
        this.props.setInitialUsersData(results);
        this.props.setUsersDataIsLoading(false);
      })
      .catch((err) => {
        console.error(err);
      })
      .finally(() => {
        this.props.setUsersDataIsLoading(false);
      });
  }
  render() {
    return (
      <div>
        <NewUserModal />
        <h5 style={{ display: "flex", alignItems: "center" }}>
          إدارة المستخدمين
          <span
            style={{
              width: 0,
              height: 0,
              borderTop: "6px solid transparent",
              borderBottom: "6px solid transparent",
              borderRight: "10px solid black",
              marginRight: "8px",
            }}
          ></span>{" "}
        </h5>
        <div className="d-flex  justify-content-between mt-3">
          <SearchUsers />
          <button
            className="btn btn-primary"
            onClick={() => this.props.showNewUserModal()}
          >
            <FontAwesomeIcon icon={faPlus} size="lg" />
            <span className="ms-2">إنشاء حساب جديد </span>
          </button>
        </div>
        <hr />
        <UsersTable isLoading={this.props.isLoading} />
      </div>
    );
  }
}

const mapDispatchToProps = {
  showNewUserModal,
  setUsers,
  setInitialUsersData,
  setUsersDataIsLoading,
};
const mapStateToProps = (state) => ({
  isLoading: state.UsersState.usersDataIsLoading,
  faculty_id: state.userState.faculty_id,
});
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(UsersAccountManagement);
